import React, { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Stack } from '@mui/material'

import { trackEvent } from 'analytics'
import { Device, Map } from '../types'
import ActionModal from 'components/Modal/ActionModal'
import { useAccessPointZonesContext } from '../AccessPointZonesContext'

const Disable = ({ map, onClose }) => {
  const { t } = useTranslation()
  const { apiActions, tree } = useAccessPointZonesContext()

  const devices = useMemo(() => {
    const items = tree[0].data.type === 'site'
      ? tree[0].children
      : tree
    const surface = items.find(({ children }) => children.find(({ data }) => map.uuid === (data as Device).uuid))
    if (!surface) {
      return []
    }
    const mapTree = surface.children.find(({ data }) => (data as Map).uuid === map.uuid)
    if (!mapTree || mapTree.data.type !== 'map') {
      return []
    }
    return mapTree.data.devices.filter(({ radio_enabled }) => radio_enabled)
  }, [map, tree])

  const connectedStations = useMemo(() => {
    return devices
      .reduce((acc, { connected_stations }) => acc + connected_stations, 0)
  }, [devices])

  useEffect(() => {
    trackEvent('access_point_zones_disable_opened', {
      scope: 'floor',
      source: 'tree',
      device_count: devices.length,
      connected_stations: connectedStations
    })
  }, [])

  const handleSubmit = async () => {
    await apiActions.update({ devices, enabled: false, scope: 'floor', source: 'tree' })
    onClose()
  }

  return (
    <ActionModal
      cancelLabel={t('ui_elements.cancel')}
      confirmLabel={t('ui_elements.disable')}
      description={(
        <Stack gap={2}>
          <Box
            sx={{
              fontSize: 14,
              textAlign: 'center'
            }}
            dangerouslySetInnerHTML={{ __html: t('access_point_zones.delete.detail') }}
          />
          {connectedStations > 0 && (
            <Box
              sx={{
                fontSize: 14,
                textAlign: 'center'
              }}
              dangerouslySetInnerHTML={{ __html: t('access_point_zones.delete.detail_disclaimer', { count: connectedStations }) }}
            />
          )}
        </Stack>
      )}
      loading={apiActions.loading}
      onClose={onClose}
      onConfirm={handleSubmit}
      title={t('access_point_zones.delete.title')}
    />
  )
}

export default Disable